import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Button } from "@components/Button";
import { BinIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { useDeleteCustomerWithPermissionsMutation } from "@services/customer/mutations";

interface IDeletePayerModalProps extends IUseModalProps {
  jointBillServiceId: number;
  payerId: number;
}

export const DeletePayerModal: React.FC<IDeletePayerModalProps> = (props) => {
  const { payerId, jointBillServiceId, ...modalProps } = props;
  const { t } = useTranslation();
  const modal = useModal(modalProps);

  const { mutateAsync, isPending } = useDeleteCustomerWithPermissionsMutation();

  const onRemove = async () => {
    const response = await mutateAsync({
      customerId: payerId,
      jointBillServiceId: jointBillServiceId,
    }).catch(() => {
      toast.error(t("toast.error"));
    });

    if (response) {
      modal.close();
      toast.success(t("deletePayerModal.toast.success"));
    }
  };

  return (
    <Modal
      modal={modal}
      badgeProps={{ icon: BinIcon, color: "red" }}
      title={t("deletePayerModal.title")}
      subtitle={t("deletePayerModal.subtitle")}
      actionButtons={
        <React.Fragment>
          <Button className="w-full" variant="secondary" onClick={modal.close}>
            {t("deletePayerModal.buttons.cancel")}
          </Button>
          <Button
            className="w-full"
            onClick={onRemove}
            isLoading={isPending}
            disabled={isPending}
          >
            {t("deletePayerModal.buttons.submit")}
          </Button>
        </React.Fragment>
      }
    ></Modal>
  );
};
